export default {
  lang: {
    sale: "매출",
    invoice: "세금관리",
    production: "생산",

    delivery: "거래",
    construction: "시공",
    goods: "화물",
    express: "택배",
    speedy: "퀵",
    progress: "진척",
    shipment: "출하",

    stock: "자재",
    title_material: "자재관리",
    title_stock: "재고관리",
    title_stock_history: "재고변동이력",
    title_delivery: "출하현황",
    title_undelivered: "미출하관리",
    title_express: "출하업체등록",
    inbound: "입고",
    title_inbound: "입고현황",

    as: "A/S",

    department: "부서",
    product_ownership_list: "보유제품리스트",
    code: "코드",
    operator_log_in_or_modify: "A/S작업자등록/수정",

    workplace: "작업장소",
    account_classification: "계정구분",
    bill_cost: "과금금액",
    DC_amount: "DC금액",
    amount_received: "실수금액",
    collection_date: "수금일자",
    whether_collect: "수금여부",
    bill_amount: "과금금액",

    production_number: "생산번호",
    installation_site: "설치장소",
    receipt_date: "접수일",
    access_date: "방문일",
    address: "주소",
    receiver: "접수자",
    fault_symptom: "고장증상",
    cost: "비용",
    person_in_charge: "담당",
    work_item: "작업사항",
    list_update: "리스트 갱신",
    search_period: "검색일자",

    management: "경영",
    title_management: "경영관리",
    title_receivablenote: "받을 어음관리",
    title_purchasenote: "결제 어음관리",

    base: "기초",
    title_base: "기초관리",
    title_code: "코드관리",
    title_customer: "거래처관리",
    title_product: "품목관리",
    title_bom: "품목별BOM관리",
    title_safety: "안전재고관리",
    title_history: "변경이력",
    title_cost: "단가관리",
    title_company: "회사정보",

    system: "시스템",
    title_system: "시스템관리",
    title_user: "사용자관리",
    title_group: "사용자그룹관리",
    title_task: "생산작업관리",
    title_process: "생산공정관리",

    code_type: "코드 구분",
    product: "품목",
    customer: "거래처",
    estimation: "견적",
    contract: "수주",
    process: "공정",
    task: "작업",
    transaction: "거래",

    code_rule: "생성 규칙",

    base_price: "기본가",

    No: "No",
    product_number: "제품코드",
    product_name: "품목",
    classify: "분류",
    material_name: "품목명",
    material_classification: "품목분류",
    quantity: "수량",
    unit: "단위",
    search: "검색",
    please_choose: "선택하세요",
    unitEA: "EA",
    user_id: "계정",
    user_name: "이름",
    user_tel: "연락처",
    user_group: "그룹",
    last_login: "최종로그인",
    notes: "비고",
    desc: "비고",
    login_users: "등록사용자수",
    final_reviser: "최종수정자",
    final_reviser_date: "최종수정시간",
    group_name: "그룹명",
    have_authority: "권한 있음",
    no_authority: "권한 없음",
    task_name: "작업 명칭",
    task_user: "작업자",
    logged_person: "등록인",
    logged_date: "등록일",
    task_login: "작업 등록",

    initial_login_date: "최초 등록일",
    process_name: "공정명",
    work_number: "작업 수",
    loginer: "등록인",
    change_date: "변경일",
    process_work_list: "공정 작업 리스트",
    order: "발주",
    work_one: "작업1",
    work_two: "작업2",

    purchase_number: "발주번호",
    id: "ID",
    material_color: "Color",
    material_size: "Size",
    warehousing_quantity: "입고수량",
    current_inventory: "현재 수량",
    warehousing_date: "입고일",
    state: "상태",

    detail_number: "명세서번호",
    whether_issue: "발행여부",
    customer_name: "거래처",
    destination: "도착지",
    delivery_date: "납기일",
    phone_number: "전화번호",
    subscriber: "주문자",
    shipping_mode: "출하방법",

    list_title: "거래명세서 리스트",
    issue: "발행여부",
    check: "검수",
    list_Packing: "포장 실적 등록",
    placeholder_pack: "명세서번호, 거래처, 목적지",
    placeholder_plan: "No., initial login, sales category, product category",

    list_title_plan: "수주 리스트",
    contract_date: "수주일",
    contract_code: "수주번호",
    contract_amount: "수주량",
    production_amount: "생산량",
    specification: "사양",

    list_title_production_plan: "생산 지시 리스트",
    production_plan_date: "생산계획",
    project_number: "공정번호",

    work_instruction_list: "작업지시 리스트",
    material_number: "품목번호",
    current_quantity: "현재고",
    safety_stock: "안전재고",
    production_performance_registration: "생산실적등록",
    label: "라벨",
    packing: "포장",

    material_inventory: "자재 재고 리스트",
    content: "내용",
    altered_person: "변경인",

    sales_classification: "판매구분",
    product_classification: "품목구분",
    categories: "제품구분",
    material_logon: "품목등록",
    classification_composition_login: "품목구성등록",

    indication_quantity: "지시수량",
    result_quantity: "생산수량",
    bad_quantity: "불량수량",

    software_consulting:
      "소프트웨어 문의: (주)아브로소프트코리아 [Tel.02-2132-5115]",
    homepage: "http://www.avrosoft.co.kr",

    product_process: "제품공정",
    product_bom: "BOM",
    product_option: "옵션",
    collect: "수금",
    asset: "자산",
    service: "A/S",
    product_price: "제품단가",
    user: "사용자",
    note: "어음",
    production_num: "생산번호",
    good: "제품",
    customer_level: "거래처등급",
    size: "규격",
    product_type: "품목구분",
    product_category: "제품구분",
    transaction_detail: "거래명세서",
    service_collect: "A/S 수금",
    contract_detail: "수주 상세",
    order_detail: "발주 상세",
    product_stock: "재고",
    bom: "BOM",
    income: "수입",
    product_glass_price: "유리단가",
    created_user_name: "등록자",
    modified_user_name: "수정자",
    created_at: "등록일",
    modified_at: "수정일",
    buy: "매입",
    wallet: "금전출납",
    schedule: "일정",
    notice: "공지",
    branch: "부서",
    expense: "지출",
    pay: "결제",
    account: "계좌",
    customer_glass_level: "유리등급",
    config: "설정",
    library: "라이브러리",
    option: "기계옵션",
    serial: "품번",
  },
  title: {
    sale: "매출관리",
    estimation: "견적관리",
    contract_reg: "수주등록",
    contract_management: "주문관리",
    contract: "수주현황",
    contract_cancel: "수주취소내역",
    trade: "거래명세서관리",
    collection: "수금업체별현황",
    uncollected: "미수금현황",
    invoice: "세금관리",
    buy_invoice: "매입세금계산서",
    sale_invoice: "매출세금계산서",
    sale_stat: "매출현황",
    sale_reg: "매출관리",
    sale_orders: "미매출현황",
    collect_stat: "수금현황",

    as: "A/S관리",
    as_handle: "A/S처리",
    as_reg: "A/S등록",
    as_calendar: "A/S일정현황",
    as_collection: "A/S과금액관리",

    production: "생산관리",
    production_result: "생산실적관리",
    production_plan: "생산지시관리",
    production_pack: "포장관리",
    production_shipment: "출하관리",

    buy: "구매관리",
    order_stat: "발주현황",
    order: "발주관리",
    order_reg: "발주등록",
    inbound: "입고관리",
    orders: "미입고현황",
    pay: "결제업체별현황",
    pay_stat: "결제현황",
    unpaid: "미결제현황",

    bom: "BOM관리",

    asset: "자금관리",
    account: "계좌관리",
    asset_category: "계정관리",
    asset_reg: "출납장",
    asset_status: "출납현황",

    product: "품목관리",
    dashboard: "대시보드",
    task: "업무관리",
    integrated_schedule: "종합일정",
    area: "구역관리",
    note: "어음관리",
    sale_ledger: "매출원장",
    glass_cost: "유리단가",
    glass: "유리관리",
    glass_color: "유리색상",
    glass_thickness: "유리두께",
    glass_mapping: "유리구성",
    buy_ledger: "매입원장",
    branch: "부서관리",
    notice: "공지관리",
    stock: "자재관리",
    base: "기초관리",
    system: "시스템관리",
    wallet: "금전출납",
    management: "경영관리",
    buy_stat: "매입현황",
    library: "라이브러리",
    customer: "거래처관리",
    /**
     * ERP-554 거래처 등급 설정 기능
     * customer_level 값이 '거래처등급관리' 였으나,
     * 위의 이슈로 인해 '거래처등급관리' 기능이 추가되어 '기계등급관리'로 수정
     * 기존에 customer_level로 적용된 다수의 부분들이 있어 문구만 수정하고 변수는 유지
     * 대신 '거래처등급관리' 기능을 위해 변수 client_level 추가
     */
    customer_level: "기계등급관리",
    client_level: "거래처등급관리",
    product_type: "품목구분관리",
    product_category: "제품구분관리",
    customer_glass_level: "유리등급",
    option: "옵션관리",
    goods_option: "기계옵션관리",
    serial_print: "품번출력",
    serial: "품번현황",
    schedule: "업무관리",
    good: "품번관리",
    settlement: "결산현황",
    company: "회사정보",
    door: "도어관리",
    door_color: "도어색상",
    customer_door_level: "도어등급",
    door_mapping: "도어구성",
    door_color_cost: "도어색상단가",
    door_cost: "도어단가",
    door_option: "도어옵션",
  },
  button: {
    login: "로그인",
    add: "추가",
    search: "검색",
    save: "저장",
    register: "등록",
    modify: "수정",
    delete: "삭제",
    close: "닫기",
    yes: "예",
    no: "아니요",
    ok: "확인",
    cancel: "취소",
    login_modify: "등록 혹은 수정",

    serachTime: "기간",
    password_initialization: "비밀번호초기화",

    packaging_acceptance: "포장검수",
    packaging_finish: "포장완료",
    list_printing: "리스트출력",
    packaging_cancelled: "포장취소",
    list_update: "리스트 갱신",

    production_logon: "생산등록",
    production_cancel: "생산취소",
    production_Internal: "내부생산",

    production_start: "생산시작",
    result_regist: "실적등록",
    failure_regist: "불량등록",
    production_complete: "생산완료",
    print: "인 쇄",

    material_inventory: "자재 재고 리스트",
    regist_safety_stock: "안전재고 등록",
    manual_shipment: "수동출하",
    cancel_shipment: "출하취소",
    add_owned_products: "보유제품추가",
    save_temp: "임시저장",
    bulk_change: "일괄변경",
  },
  message: {
    success_create: "추가되었습니다.",
    success_update: "수정되었습니다.",
    success_delete: "삭제었습니다.",
    success_register: "등록었습니다.",
    warn_code_total_length: "자릿수의 합은 20자를 넘지 않아야 합니다.",
    wrong: "에러",
    cannot_be_repeated: "작업은 중복 선택 할 수 없습니다.",
    must_be_selected: "작업1은 필수선택입니다.",
    please_choose_task_name: "작업을 선택하세요.",
    please_choose_task_user: "작업자를 선택하세요.",
    please_choose_classify: "구분을 선택하세요.",
    please_choose_code: "명세서번호, 거래처",
    choose_date: "날짜 선택",
    please_choose: "선택하세요.",
    please_enter_delivery_date: "납기일을 입려가세요.",
    please_enter_customer: "거래처명을 입력하세요.",
    please_enter_code: "번호를 입력하세요.",
    please_enter_installation_site: "설치장소를 입력하세요.",
    please_enter_product: "품목을 입력하세요.",
    please_enter_color: "옵션1 입력하세요.",
    please_enter_size: "옵션2 입력하세요.",
    please_enter_unit: "단위를 입력하세요.",
    please_enter_quantity: "수량을 입력하세요.",

    please_enter_the_receiving_date: "접수일을 입력하세요.",
    please_enter_the_access_date: "방문일을 입력하세요.",
    please_select_the_receiver: "접수자을 선택하세요.",
    please_enter_the_fault_details: "고장증상상세를 입력하세요.",
    please_enter_price: "과금금액을 입력하세요.",
    please_enter_discount_price: "할인금앱을 입력하세요.",
    please_enter_collected_price: "실수금액을 입력하세요.",
    no_selection: "선택한 항목이 없습니다.",
  },
  error: {
    2: "존재하지 않는 데이터입니다.",
    3: "사용되고 있는 데이터입니다.",
    4: "중복된 데이터입니다.",
    5: "상태 변경에 실패하였습니다.",
    6: "값이 적절하지 않습니다.",
    7: "변경할 수 없는 항목이 변경되었습니다.",
    8: "이미 등록 된 데이터가 존재합니다.",
  },
};
